/**
* Overlapping Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Overlapping Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'overlapping-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let mobile = false;
      let loggedIn = false;
      if ( window.innerWidth < 1024 ) {
        mobile = true;
      }
      if ( $( '.logged-in' ).length > 0 ) {
        loggedIn = true;
      }

      let top = '120px';
      if ( mobile === true ) {
        top = '9px';
      }
      if ( loggedIn === true && mobile === false ) {
        top = '152px';
      }
      if ( mobile === true && loggedIn === true ) {
        top = '142px';
      }
      $( window ).on( 'resize', function() {
        let top = '120px';
        if ( mobile === true ) {
          top = '9px';
        }
        if ( loggedIn === true && mobile === false ) {
          top = '152px';
        }
        if ( mobile === true && loggedIn === true ) {
          top = '142px';
        }
      } );
      if ( window.innerWidth > 768 ) {
        $( '.overlapping-card_card.animate' ).each( function() {
          const lessHeight = $( this ).height();
          $( this ).css( 'margin-top', '-'+lessHeight+'px' );
        } );

        const overlappingCards = gsap.utils.toArray( '.overlapping-card_card.animate' );

        gsap.from( overlappingCards, {
          yPercent: 100,
          ease: 'none',
          stagger: 1,
          scrollTrigger: {
            trigger: '.overlapping-card_card',
            start: 'top top+=' + top + 'px',
            pin: '.overlapping-cards',
            // markers: true,
            scrub: 1.5,
            // snap: 1 / ( overlappingCards.length - 1 ),
            end: () => '+=' + ( document.querySelector( '.overlapping-cards' ).offsetHeight ),
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'overlapping-cards', COMPONENT );
} )( app );
